"use client";

import { createContext, useContext, useMemo } from "react";
import { usePathname } from "next/navigation";

export type BrandMode = "montmar" | "segurclassic";

interface BrandContextValue {
  mode: BrandMode;
  isSegurclassic: boolean;
}

const BrandContext = createContext<BrandContextValue>({
  mode: "montmar",
  isSegurclassic: false,
});

export function BrandProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const value = useMemo<BrandContextValue>(() => {
    const isSegurclassic =
      pathname.startsWith("/emision") || pathname.startsWith("/pre-clasicos");
    return {
      mode: isSegurclassic ? "segurclassic" : "montmar",
      isSegurclassic,
    };
  }, [pathname]);

  return (
    <BrandContext.Provider value={value}>{children}</BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
